import React from 'react';
import {
    BubbleExChart,
    DoughnutExChart, FunnelExChart,
    PiExChart,
    SimpleBarExChart,
    SplineExChart,
    StackedBarExChart, TreeMapExChart, SimpleCounter, palette, source,
    sourceHit, sourceCompare, sourceLoss, sourceTotal, HealthCheck, QMCounter, SpeedometerChart, sourceAvarage, sourceDays
} from './DevExtremeWidgets';
import { Spinner } from 'office-ui-fabric-react/lib';
import { queryReportData } from "../../../queries/queryReport";
import { Query } from 'react-apollo';
import TagCloud from './TagCloud/TagCloud';
import { MyContext } from '../../../context';

const frameStyle = {
    margin: 4 * 2,
    padding: 4 * 2,
    sizeSmal: 76 * 2,
    sizeBig: 178 * 2,
    footer: 40,

};

class DevboardWidget extends React.Component {
    static contextType = MyContext
    constructor(props) {
        super(props);
        this.reportConf = React.createRef();
        this.state = {
            query: 0,
        };
        this.data = null;
        // link handleLoading with context
        this.handleLoading = this.handleLoading.bind(this);
    }


    refetchQuery = null;

    refreshData = () => {
        this.refetchQuery()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sectionName != this.props.sectionName) {
            this.refreshData()
        }
    }

    handleLoading = () => {
        if (typeof this.props.changeLoadingStatus === 'function' && (this.props.sectionName != undefined || this.props.isBackButton)) {
            this.props.changeLoadingStatus();
        }/* else {
            console.error("changeLoadingStatus is not a function");
        }*/
    }

    render() {
        var input = this.props.input;
        var id = this.props.element.id;
        var inputData = {
            input,
            id
        };
        if (this.props.sectionName != undefined) {
            inputData = { ...inputData, sectionName: this.props.sectionName }
        }



        return (
            this.queryWidget(this.props.element, inputData)
        )
    }

    getDataSimpleBarForCase = (elementData) => {
        let dataElement = elementData;
        if (this.props.element.type === "time" && elementData !== null) {
            dataElement = elementData.map(e => {
                return {
                    value: e.inbound,
                    args: e.time
                }
            })
        }
        if (this.props.element.type === "user" && elementData !== null) {
            dataElement = elementData.map(e => {
                return {
                    value: e.hit,
                    args: this.props.element.persons.filter(p => p.userId === e.args)[0]?.name
                }
            })
        }

        return dataElement
    }

    getDataSimpleBarForCaseContent = (elementData) => {
        let dataElement;
        let series;
        if (this.props.element.type === "time" && elementData !== null && elementData.length > 0) {
            dataElement = elementData.map(d => {
                const row = { time: d.time };

                d.items.forEach(item => {
                    row[item.args] = item.value;
                });

                return row;
            });
            series = elementData[0].items.map(item => ({
                argumentField: "time",
                valueField: item.args,
                name: item.args
            }));
        }
        if (this.props.element.type === "case" && elementData !== null) {
            dataElement = elementData
            series = [{
                argumentField: "args",
                valueField: "noHit",
                name: this.context.getTranslation("compliance", (this.props.element.kpi === "CaseComplianceRate" ? "notCompliant" : "notEscalated"))
            }, {
                argumentField: "args",
                valueField: "hit",
                name: this.context.getTranslation("compliance", (this.props.element.kpi === "CaseComplianceRate" ? "compliant" : "escalated"))
            }]
        }
        if (this.props.element.type === "user" && elementData !== null) {
            dataElement = elementData.map(d => {
                const [contentId, caseName] = d.args.split(",");
                return {
                    [caseName]: d.hit,
                    args: this.props.element.persons.filter(p => p.userId === contentId)[0]?.name
                };
            });
            const cases = [];
            elementData.forEach(d => {
                const [contentId, caseName] = d.args.split(",");
                if (!cases.includes(caseName)) {
                    cases.push(caseName);
                }
            })
            series = cases.map(item => ({
                argumentField: "args",
                valueField: item,
                name: item
            }));
        }
        //console.log("dataElement", dataElement)
        //console.log("series", series)
        return { dataElement, series };
    }

    add10AndRoundUp = (number) => {
        const noDecimals = Math.floor(number);     // ignore decimals
        const added = noDecimals + 10;              // add 10
        const roundedUp = Math.ceil(added / 10) * 10; // round up to nearest ten
        return roundedUp;
    }

    roundNumericValues = (data) => {
        return data.map(item => {
            const roundedItem = {};
            for (const key in item) {
                if (typeof item[key] === 'number') {
                    roundedItem[key] = Math.round(item[key]);
                } else {
                    roundedItem[key] = item[key];
                }
            }
            return roundedItem;
        });
    };

    queryWidget = (element, inputData) => (

        <Query
            key={`query:${element.id}`}
            query={queryReportData}
            variables={inputData}
            {...(inputData.sectionName != undefined && { fetchPolicy: "network-only" })}
            onCompleted={(data) => {
                this.data = data;
                this.handleLoading();
            }}
        >
            {({
                loading, error, data, refetch,
            }) => {
                this.refetchQuery = refetch;
                if (loading) return <Spinner label="Loading..." ariaLive="assertive" labelPosition="top" />;
                if (error) return <h1> </h1>;
                if (data.getReportData != null) {
                    let size_w; let
                        size_h;
                    if (this.props.resize === true) {
                        size_h = -1;
                        size_w = -1;
                    } else {
                        size_w = frameStyle.sizeBig;
                        size_h = frameStyle.sizeBig;
                    }

                    let dataTotal = [];
                    if (data.getReportData.data?.total !== null) {
                        dataTotal = data.getReportData.data?.total;
                    }
                    let elementData = null;
                    let tempArr = [];
                    switch (this.props.element.type) {
                        case 'total':
                            if (this.props.element.conversationType !== null
                                && this.props.element.conversationType.length !== 0
                                && this.props.element.kpi !== "CC"
                                && this.props.element.kpi !== "AU"
                                && this.props.element.kpi !== "CNR"
                                && this.props.element.kpi !== "ActiveUser"
                                && this.props.element.kpi !== "UserCheck"
                                && this.props.element.kpi !== "HealthCheck"
                                && this.props.element.kpi !== "Export"
                                && this.props.element.kpi !== "Exported"
                                && this.props.element.kpi != "CategoryCompared"
                                && this.props.element.kpi != "PolicyCompared"
                            ) {
                                dataTotal.map(el => {
                                    if (this.props.element.conversationType.includes(el.args)) {
                                        tempArr.push(el);
                                    }
                                });

                                elementData = tempArr;

                            }
                            if (this.props.element.kpi === "CT" || this.props.element.kpi == "AgentTalkTime") {
                                if (this.props.element.valueType === "duration") {
                                    elementData = this.roundNumericValues(data.getReportData.data.total)
                                } else {
                                    elementData = data.getReportData.data.total
                                }
                            } else if (this.props.element.kpi == "AICategorizationKPI") {
                                //we access first element because at the moment we only consider one AI categorization when creating the graph,
                                //cheges may be needed in case we have more than one AI cat.
                                elementData = data.getReportData.data.keymap != null && data.getReportData.data.keymap.length > 0 ?
                                    data.getReportData.data.keymap[0].items : []
                            }
                            else {
                                elementData = data.getReportData.data.total;
                            }
                            break;
                        case 'keymap':
                            elementData = data.getReportData.data.keymap;
                            break;
                        case 'time':
                            if (this.props.element.valueType === "duration") {
                                elementData = this.roundNumericValues(data.getReportData.data.time)
                            } else {
                                elementData = data.getReportData.data.time;
                            }
                            break;
                        case "scorecardPerformance":
                        case 'user':
                            elementData = data.getReportData.data.total;
                            break;
                        case "sectionUser":
                            elementData = data.getReportData.data.user;
                            break;
                        case 'TagCloud':
                            elementData = data.getReportData.data.keymap != null && data.getReportData.data.keymap.length > 0 ?
                                data.getReportData.data.keymap[0].items : []
                            break;
                        case "case": {
                            elementData = data.getReportData.data.total;
                            break;
                        }
                        case 'number':
                        default:
                            if (this.props.element.widget === 'TagCloud') {
                                elementData = data.getReportData.data.keymap != null && data.getReportData.data.keymap.length > 0 ?
                                    data.getReportData.data.keymap[0].items : []
                            } else {
                                elementData = data.getReportData.data?.text;
                            }
                    }

                    var defaultVisualRange = undefined;

                    if (elementData === null) {
                        return <Spinner label="Loading..." ariaLive="assertive" labelPosition="top" />
                    }

                    switch (this.props.element.widget) {
                        case 'TagCloud':
                            var words = elementData !== null ? elementData.map(e => (
                                {
                                    value: e.value,
                                    text: e.name,
                                }
                            )) : []
                            if (words.length > 0) {
                                //big size inside modal
                                if (this.props.resize) {
                                    return <TagCloud
                                        tags={words}
                                        containerDim={[1400, 550]}
                                        fontSize={[10, 100]}
                                    //onClickTag={(tag) => console.log(tag)}
                                    />
                                }
                                //standard size
                                else if (!this.props.resize && window.innerWidth > 650) {
                                    return <TagCloud
                                        tags={words}
                                    //fontSize={[10, 60]}
                                    //onClickTag={(tag) => console.log(tag)}
                                    />
                                }
                                //small screen - less words
                                else if (!this.props.resize && window.innerWidth <= 650) {
                                    words.sort((a, b) => b.value - a.value);
                                    const onlyTopWords = words.slice(0, 20);
                                    return <TagCloud
                                        tags={onlyTopWords}
                                        containerDim={[320, 350]}
                                    //fontSize={[10, 60]}
                                    //onClickTag={(tag) => console.log(tag)}
                                    />
                                }
                            } else if (words.length == 0) {
                                return <div style={{ height: "200px" }}>
                                    <div style={{ marginTop: "140px" }}>NO DATA FOUND</div>
                                </div>
                            }
                            break;
                        case 'DoughnutChart': {
                            const keywords = (this.props.element.kpi === "QMAgentCompared" ||
                                this.props.element.kpi === "OverallComplianceRate" ||
                                this.props.element.kpi === "OverallEscalationRate" ||
                                this.props.element.kpi === "CaseComplianceRate" ||
                                this.props.element.kpi === "CaseEscalationRate"
                            )
                                ? data.getReportData.data.text : this.props.element.keywords
                            return (
                                <DoughnutExChart
                                    kpi={this.props.element.kpi}
                                    reference={this.props.reference}
                                    palette={palette}
                                    data={elementData}
                                    type={this.props.element.type}
                                    labelCenter={keywords}
                                    overflow={data.getReportData.data.overflow}
                                    size={{
                                        width: size_w,
                                        height: size_h,
                                    }}
                                />
                            );
                        }
                        case 'SplineChart':
                            var tmpSource = [];
                            if (this.props.element.conversationType !== null && this.props.element.conversationType.length !== 0) {
                                source.map(el => {
                                    if (this.props.element.conversationType.includes(el.name)) {
                                        tmpSource.push(el);
                                    }
                                });

                            } else {
                                tmpSource = source;
                            }
                            var sourceTypes = tmpSource;
                            switch (this.props.element.kpi) {
                                case "GCTA":
                                case "CTA":
                                case "CIA":
                                case "COA":
                                case "CMA":
                                case "CEA":
                                    sourceTypes = sourceCompare;
                                    break;
                                case "GCNR":
                                case "CNR": {

                                    // (if)Filter sourceLoss list based on problemType
                                    //(else)if problemTypes is empty read data and all data with 0 will eliminate the source item from the list to avoid having to many entries by default
                                    let tmpSourceLoss = [];

                                    if (this.props.element?.problemTypes && this.props.element.problemTypes.length > 0) {

                                        sourceLoss.map(el => {
                                            if (this.props.element.problemTypes.map(pt => pt.toLowerCase()).includes(el.value.toLowerCase())) {
                                                tmpSourceLoss.push(el);
                                            }
                                        });


                                    } else {
                                        tmpSourceLoss = sourceLoss.filter(item => {
                                            return elementData.some(dataItem => dataItem[item.value] !== 0);
                                        });
                                    }

                                    sourceTypes = tmpSourceLoss;

                                    break;
                                }
                                case "OverallComplianceRate":
                                case "OverallEscalationRate":
                                    sourceTypes = sourceAvarage;
                                    break;
                                case "OverallResolutionTime":
                                case "CaseResolutionTime":
                                    sourceTypes = sourceDays;
                                    break;
                                case "AU":
                                    sourceTypes = sourceTotal;
                                    break;
                                case "PolicyCompared":
                                case "CategoryCompared":
                                    sourceTypes = sourceHit;
                                    break;
                                case "CaseComplianceRate":
                                case "CaseEscalationRate": {
                                    if (elementData !== null) {
                                        sourceTypes = Object.values(
                                            elementData.flatMap(t => t.items)
                                                .reduce((acc, i) => {
                                                    acc[i.args] = acc[i.args] || { name: i.args, value: 0 };
                                                    acc[i.args].value = i.args;
                                                    return acc;
                                                }, {})
                                        );
                                        //console.log("sourceTypes", sourceTypes);
                                        elementData = elementData.map(t => {
                                            const row = { time: t.time };
                                            t.items.forEach(i => {
                                                row[i.args] = i.value;
                                            });
                                            return row;
                                        });
                                        //console.log("elementData", elementData);
                                    }
                                    break;
                                }
                                case "QMAgentCompared": {
                                    if (elementData !== null) {
                                        sourceTypes = this.props.element.persons.map(p => { return { value: p.id, name: p.name } });
                                        elementData = elementData?.map(e => {
                                            const transformedUsers = e.users.reduce((acc, user) => {
                                                acc[user.userId] = user.value;
                                                return acc;
                                            }, {});
                                            return { ...e, ...transformedUsers }
                                        });
                                        const totalPoints = data.getReportData.data.text !== "" && data.getReportData.data.text !== null ?
                                            parseFloat(data.getReportData.data.text.replace(",", ".")) : null;
                                        defaultVisualRange = totalPoints !== null ? [0, totalPoints] : undefined;
                                    }
                                    break;
                                }

                            }
                            return (
                                <SplineExChart
                                    kpi={this.props.element.kpi}
                                    reference={this.props.reference}
                                    palette={palette}
                                    source={sourceTypes}
                                    data={elementData}
                                    type={this.props.element.type}
                                    overflow={data.getReportData.data.overflow}
                                    defaultVisualRange={defaultVisualRange}
                                    size={{
                                        width: size_w,
                                        height: size_h,
                                    }}
                                />
                            );
                        case 'PieChart': return (
                            <PiExChart
                                kpi={this.props.element.kpi}
                                reference={this.props.reference}
                                data={elementData}
                                type={this.props.element.type}
                                palette={palette}
                                overflow={data.getReportData.data.overflow}

                                size={{
                                    width: size_w,
                                    height: size_h,
                                }}
                            />
                        );
                        case 'SimpleBarChart': {
                            let dataElement = elementData
                            let series = null;
                            if (this.props.element.kpi === "QMAgentCompared" && elementData !== null) {
                                dataElement = elementData.map(e => {
                                    return {
                                        ...e,
                                        args: this.props.element.persons.filter(p => p.userId === e.args)[0]?.name
                                    }
                                })
                                const totalPoints = data.getReportData.data.text !== "" && data.getReportData.data.text !== null ?
                                    parseFloat(data.getReportData.data.text.replace(",", ".")) : null;
                                defaultVisualRange = totalPoints !== null ? [0, totalPoints] : undefined;
                            }
                            if (this.props.element.kpi === "OverallComplianceRate" || this.props.element.kpi === "OverallEscalationRate") {
                                dataElement = this.getDataSimpleBarForCase(elementData)
                                defaultVisualRange = [0, 100]
                            }
                            if (this.props.element.kpi === "OverallResolutionTime" || this.props.element.kpi === "CaseResolutionTime") {
                                dataElement = this.getDataSimpleBarForCase(elementData)
                            }
                            if (this.props.element.kpi === "CaseComplianceRate" || this.props.element.kpi === "CaseEscalationRate") {
                                dataElement = this.getDataSimpleBarForCaseContent(elementData).dataElement
                                series = this.getDataSimpleBarForCaseContent(elementData).series
                            }
                            return (
                                <SimpleBarExChart
                                    reference={this.props.reference}
                                    data={dataElement}
                                    kpi={this.props.element.kpi}
                                    type={this.props.element.type}
                                    palette={palette}
                                    overflow={data.getReportData.data.overflow}
                                    defaultVisualRange={defaultVisualRange}
                                    size={{
                                        width: size_w,
                                        height: size_h,
                                    }}
                                    series={series}
                                />
                            );
                        }
                        case 'StackedBarChart':
                            {
                                if (this.props.resize && this.props.sectionName == undefined) {
                                    return (
                                        <StackedBarExChart
                                            palette={palette}
                                            data={elementData}
                                            isModal={this.props.resize}
                                            changeSectionInfo={this.props.changeSectionInfo}
                                            sectionName={this.props.sectionName}
                                            reference={this.props.reference}
                                            type={this.props.element.type}
                                            kpi={this.props.element.kpi}
                                            overflow={data.getReportData.data.overflow}

                                            size={{
                                                width: size_w,
                                                height: size_h,
                                            }}
                                            convType={this.props.element.conversationType}
                                            problemType={this.props.element.problemTypes}
                                            name={data.getReportData.data.name}
                                            persons={this.props.element.persons}
                                        />

                                    );

                                } else {
                                    return (
                                        <StackedBarExChart
                                            palette={palette}
                                            data={elementData}
                                            isModal={this.props.resize}
                                            sectionName={this.props.sectionName}
                                            reference={this.props.reference}
                                            type={this.props.element.type}
                                            kpi={this.props.element.kpi}
                                            overflow={data.getReportData.data.overflow}
                                            size={{
                                                width: size_w,
                                                height: size_h,
                                            }}
                                            convType={this.props.element.conversationType}
                                            problemType={this.props.element.problemTypes}
                                            name={data.getReportData.data.name}
                                            persons={this.props.element.persons}
                                        />

                                    );
                                }
                            }
                        case 'TreeMap':
                            return (
                                <TreeMapExChart
                                    palette={palette}
                                    data={elementData}
                                    reference={this.props.reference}
                                    type={this.props.element.type}
                                    overflow={data.getReportData.data.overflow}

                                    size={{
                                        width: size_w,
                                        height: size_h,
                                    }}
                                />
                            );
                        case 'FunnelChart':
                            return (
                                <FunnelExChart
                                    palette={palette}
                                    data={elementData}
                                    reference={this.props.reference}
                                    type={this.props.element.type}
                                    overflow={data.getReportData.data.overflow}

                                    size={{
                                        width: size_w,
                                        height: size_h,
                                    }}
                                />
                            );
                        case 'BubbleChart':
                            return (
                                <BubbleExChart
                                    palette={palette}
                                    reference={this.props.reference}
                                    overflow={data.getReportData.data.overflow}

                                    size={{
                                        width: size_w,
                                        height: size_h,
                                    }}
                                />
                            );
                        case "Speedometer": {
                            const value = parseFloat(data.getReportData.data?.type?.replace(",", "."));
                            let range = data?.getReportData?.data?.settingItems ?? []
                            let scale = null;
                            if (this.props.element.kpi === "OverallResolutionTime" || this.props.element.kpi === "CaseResolutionTime") {
                                const endValue = this.add10AndRoundUp(value)
                                range = [
                                    { minRange: 0, maxRange: endValue < 10 ? endValue : 10, color: '#2E8B57' },
                                    { minRange: 11, maxRange: endValue < 50 ? endValue : 50, color: '#FFD700' },
                                    { minRange: 51, maxRange: endValue, color: '#8B0000' }
                                ]
                                scale = { tickInterval: 10, endValue: endValue }
                            }
                            return (
                                <SpeedometerChart
                                    reference={this.props.reference}
                                    size={{
                                        width: size_w,
                                        height: size_h,
                                    }}
                                    value={value}
                                    range={range}
                                    reverse={false}
                                    scale={scale}
                                />
                            )
                        }
                        case 'Number':
                        default:
                            {
                                let ttmp = 3;
                                if (this.props.element.alarming != null) {
                                    ttmp = this.props.element.alarming.alarmActive ? 0 : 1;
                                }
                                if (this.props.element.kpi == "HealthCheck")
                                    return (
                                        <HealthCheck
                                            color={palette[ttmp]}
                                            val={elementData}
                                            overflow={data.getReportData.data.overflow}

                                        />
                                    );
                                else if (this.props.element.kpi === "QMAgentCompared") {
                                    return <QMCounter
                                        valueType={this.props.element.valueType}
                                        color={data.getReportData.data.color}
                                        val={data.getReportData.data.type}
                                        evaluations={elementData}
                                    />
                                }
                                else if (this.props.element.valueType === "size") {
                                    const bytesValue = parseFloat(elementData);
                                    const gbValue = (bytesValue / (1024 * 1024 * 1024)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
                                    return (
                                        <SimpleCounter
                                            color={palette[ttmp]}
                                            val={gbValue}
                                            overflow={data.getReportData.data.overflow}

                                        />
                                    );
                                }
                                else
                                    return (
                                        <SimpleCounter
                                            color={palette[ttmp]}
                                            val={elementData}
                                            overflow={data.getReportData.data.overflow}

                                        />
                                    );
                            }
                    }
                }
            }}
        </Query>
    );

}

export default DevboardWidget;